import { render, staticRenderFns } from "./RaceContainer.vue?vue&type=template&id=28d2e3c5&scoped=true&"
import script from "./RaceContainer.vue?vue&type=script&lang=js&"
export * from "./RaceContainer.vue?vue&type=script&lang=js&"
import style0 from "./RaceContainer.vue?vue&type=style&index=0&id=28d2e3c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2e3c5",
  null
  
)

export default component.exports